import { createQueryString } from "../../../Services/SharedData";
import REQUEST from "../../../Services/Request";

export const GET_UNITS = async (data) => {
  console.log(data);
  return await REQUEST({
    method: "GET",
    url: "unit/filter?" + createQueryString(data),
  });

};